import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('ScrollToTop triggered for pathname:', pathname);

    // Función mejorada para asegurar el scroll al top
    const scrollToTop = () => {
      try {
        // Forzar scroll inmediato
        window.scrollTo(0, 0);

        // También intentar con document
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        // Scroll to top del elemento root
        const rootElement = document.getElementById('root');
        if (rootElement) {
          rootElement.scrollTop = 0;
        }

        console.log('Scroll attempted for:', pathname);
      } catch (error) {
        console.error('Error scrolling to top:', error);
      }
    };

    // Ejecutar inmediatamente
    scrollToTop();

    // Ejecutar después de un breve delay para asegurar que el DOM esté listo
    const timer1 = setTimeout(() => {
      scrollToTop();
      console.log('Scroll retry after delay');
    }, 50);

    // Ejecutar después de que las animaciones/transiciones terminen
    const timer2 = setTimeout(() => {
      scrollToTop();
      console.log('Scroll final attempt');
    }, 200);

    // Limpiar timers
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop;